export const WIFI_BEST_PRACTICES_STAGES = {
  INITIAL: 'initial',
}
